/* src/app/core/components/human-text-cloud/human-text-cloud.component.scss */
.human-text-cloud {
  position: absolute;
  bottom: -7px;
  display: flex;
  align-items: flex-end;
}
.image {
  width: 136px;
  height: 176.7px;
  position: relative;
  bottom: -10px;
}
.image img {
  width: 100%;
  height: 100%;
}
.text {
  padding: 10px;
  background: rgba(255, 255, 255, 0.9);
  max-width: 50%;
  max-height: 125px;
  overflow: scroll;
  position: relative;
  top: -133px;
  height: fit-content;
  border-radius: 18px;
  white-space: pre-line;
  font-size: 1em;
}
@media (min-height: 700px) {
  .text {
    max-height: 303px;
  }
}
.text p,
.text a {
  font-size: 1em;
}
.text a {
  color: #4ac8f3 !important;
}
.buttons {
  display: flex;
  position: absolute;
  flex-direction: column;
  right: 25px;
  bottom: 25px;
}
.buttons .blue {
  background: #4ac8f3;
}
.buttons button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 5px 5px 20px;
  color: #fff;
  border-radius: 100px;
  font-size: 14px;
  margin: 5px 0;
  background: rgba(181, 181, 181, 0.7);
}
.buttons button img {
  width: 24px;
  height: 24px;
  margin-left: 5px;
}
/*# sourceMappingURL=human-text-cloud.component.css.map */
